import { render, staticRenderFns } from "./ClassTeacher.vue?vue&type=template&id=61f658c3&scoped=true"
import script from "./ClassTeacher.vue?vue&type=script&lang=js"
export * from "./ClassTeacher.vue?vue&type=script&lang=js"
import style0 from "./ClassTeacher.vue?vue&type=style&index=0&id=61f658c3&prod&lang=scss&scoped=true"
import style1 from "./ClassTeacher.vue?vue&type=style&index=1&id=61f658c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f658c3",
  null
  
)

export default component.exports